export enum OnboardingStep {
  welcome = 'welcome',
  roleselect = 'roleselect',
  assigned = 'assigned',
  skills = 'skills',
  review = 'review',
  resume = 'resume',
  startLearning = 'startLearning',
}
